import omit from 'lodash/omit';

// utils
import { mapErrorsToModel } from '@/utils/api';

export const getMenu = async (apimenuid) => {
  return await window.axios
    .get('/menus/' + (apimenuid || '-default'), {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((data) => {
      return data.data;
    });
};

export const getMenus = async (pagination) => {
  let url;
  if (pagination.link) {
    url = '/menus' + new URL(pagination.link).search;
  } else {
    url = `/menus?page[size]=${pagination.pageSize}`;
  }
  return await window.axios
    .get(url + '&sort=-updated_at,created_at&filter[active]', {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then(({ data }) => {
      return { data: data.data, pagination: data.links };
    });
};

export const storeMenu = async (menu) => {
  const method = menu.id ? 'patch' : 'post';

  return await window.axios
    .request({
      url: '/menus/' + (menu.id ?? ''),
      method,
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      data: { data: omit(menu, menu.id ? [] : ['id']) },
    })
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      // Wenn Unprocessable Entity
      if (error.response.status === 422) {
        return mapErrorsToModel(error.response.data.errors);
      }
      return error.response.data;
    });
};

export const checkErrorsMenu = async (menuId) => {
  return await window.axios
    .get('/menus/-errors', {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      params: { menuId: menuId },
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteMenu = async (menuId) => {
  return await window.axios
    .delete(`/menus/${menuId}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((data) => {
      return data.data;
    });
};

export const menuCopy = async (menuId) => {
  return await window.axios
    .post(`/menus/-copy`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      data: { menuId },
    })
    .then((data) => {
      return data.data;
    });
};

export const exportMenu = async (menuId) => {
  return await fetch(`/menu-pdf/${menuId}/qualityPreview`);
};
